import type { SelectionSlice, SelectionState, ViewerSliceCreator } from "./types";

export const selectionInitialState: SelectionState = {
  selectedMeshUuid: null,
};

export const createSelectionSlice: ViewerSliceCreator<SelectionSlice> = (set) => ({
  ...selectionInitialState,

  setSelectedMesh: (uuid) =>
    set((state) => {
      state.selectedMeshUuid = uuid;
    }),
});
